// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.styles_layoutContainer__ip2Xc {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.styles_skipLink__YQ08o {
  position: absolute;
  top: -100px;
  left: 16px;
  padding: 8px 16px;
  background-color: var(--color-black);
  color: var(--color-white);
  text-decoration: none;
  font: var(--typography-label);
  border-radius: 8px;
  z-index: 9999;
  transition: top 0.2s ease;
}
.styles_skipLink__YQ08o:focus {
  top: 16px;
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.styles_mainArea__QWRl4 {
  flex: 1 1;
  display: flex;
  overflow-y: auto;
  gap: 0px;
  padding-left: 60px;
}
@media (max-width: 767px) {
  .styles_mainArea__QWRl4 {
    padding-left: 16px;
    padding-right: 16px;
  }
}

/* ── Auth Loading Screen ── */
.styles_authLoading__Dp\\+Jt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.styles_authCard__r-ZQs {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 40px;
  gap: 28px;
  width: 600px;
  max-width: 90%;
  border-radius: 40px;
  background-color: var(--color-white);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
@media (max-width: 480px) {
  .styles_authCard__r-ZQs {
    width: 100%;
    padding: 32px 16px;
    border-radius: 12px;
  }
}

.styles_authLogo__6KFj6 {
  width: 44px;
  height: 44px;
  animation: styles_authLogoFloat__j-pgw 3s ease-in-out infinite;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.25));
}
.styles_authLogo__6KFj6 path {
  fill: var(--color-blue-light);
  stroke: var(--color-blue-light);
}

@keyframes styles_authLogoFloat__j-pgw {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
.styles_authDots__SY-4R {
  display: flex;
  gap: 6px;
}

.styles_authDot__45kNk {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--color-accent-blue);
  animation: styles_authDotWave__sB75W 1.4s ease-in-out infinite;
}
.styles_authDot__45kNk:nth-child(1) {
  animation-delay: 0s;
}
.styles_authDot__45kNk:nth-child(2) {
  animation-delay: 0.15s;
}
.styles_authDot__45kNk:nth-child(3) {
  animation-delay: 0.3s;
}
.styles_authDot__45kNk:nth-child(4) {
  animation-delay: 0.45s;
}

@keyframes styles_authDotWave__sB75W {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  40% {
    transform: translateY(-8px);
    opacity: 1;
  }
}
.styles_mainContent__mEscp {
  flex: 1 1;
  position: relative;
}
.styles_mainContent__mEscp::-webkit-scrollbar {
  width: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/styles.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AACF;AACE;EACE,SAAA;EACA,uCAAA;EACA,mBAAA;AACJ;;AAGA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;AAAF;AAGE;EARF;IASI,kBAAA;IACA,mBAAA;EAAF;AACF;;AAGA,8BAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,oCAAA;EACA,yCAAA;AAAF;AAEE;EAZF;IAaI,WAAA;IACA,kBAAA;IACA,mBAAA;EACF;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,8DAAA;EACA,kDAAA;AACF;AACE;EACE,6BAAA;EACA,+BAAA;AACJ;;AAGA;EACE;IAAW,wBAAA;EACX;EAAA;IAAM,4BAAA;EAGN;AACF;AADA;EACE,aAAA;EACA,QAAA;AAGF;;AAAA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,8DAAA;AAGF;AADE;EAAiB,mBAAA;AAInB;AAHE;EAAiB,sBAAA;AAMnB;AALE;EAAiB,qBAAA;AAQnB;AAPE;EAAiB,sBAAA;AAUnB;;AAPA;EACE;IACE,wBAAA;IACA,YAAA;EAUF;EARA;IACE,2BAAA;IACA,UAAA;EAUF;AACF;AAPA;EACE,SAAA;EACA,kBAAA;AASF;AAPE;EACE,QAAA;AASJ","sourcesContent":["@import \"mixins\";\n.layoutContainer {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.skipLink {\n  position: absolute;\n  top: -100px;\n  left: 16px;\n  padding: 8px 16px;\n  background-color: var(--color-black);\n  color: var(--color-white);\n  text-decoration: none;\n  font: var(--typography-label);\n  border-radius: 8px;\n  z-index: 9999;\n  transition: top 0.2s ease;\n\n  &:focus {\n    top: 16px;\n    outline: 2px solid var(--color-primary);\n    outline-offset: 2px;\n  }\n}\n\n.mainArea {\n  flex: 1;\n  display: flex;\n  overflow-y: auto;\n  gap: 0px;\n  padding-left: 60px;\n\n  // Mobile: remove left padding since sidebar is hidden, add horizontal padding for spacing\n  @media (max-width: 767px) {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n/* ── Auth Loading Screen ── */\n.authLoading {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.authCard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 48px 40px;\n  gap: 28px;\n  width: 600px;\n  max-width: 90%;\n  border-radius: 40px;\n  background-color: var(--color-white);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n\n  @media (max-width: 480px) {\n    width: 100%;\n    padding: 32px 16px;\n    border-radius: 12px;\n  }\n}\n\n.authLogo {\n  width: 44px;\n  height: 44px;\n  animation: authLogoFloat 3s ease-in-out infinite;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.25));\n\n  path {\n    fill: var(--color-blue-light);\n    stroke: var(--color-blue-light);\n  }\n}\n\n@keyframes authLogoFloat {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-10px); }\n}\n\n.authDots {\n  display: flex;\n  gap: 6px;\n}\n\n.authDot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--color-accent-blue);\n  animation: authDotWave 1.4s ease-in-out infinite;\n\n  &:nth-child(1) { animation-delay: 0s; }\n  &:nth-child(2) { animation-delay: 0.15s; }\n  &:nth-child(3) { animation-delay: 0.3s; }\n  &:nth-child(4) { animation-delay: 0.45s; }\n}\n\n@keyframes authDotWave {\n  0%, 80%, 100% {\n    transform: translateY(0);\n    opacity: 0.4;\n  }\n  40% {\n    transform: translateY(-8px);\n    opacity: 1;\n  }\n}\n\n.mainContent {\n  flex: 1;\n  position: relative;\n\n  &::-webkit-scrollbar {\n    width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layoutContainer": `styles_layoutContainer__ip2Xc`,
	"skipLink": `styles_skipLink__YQ08o`,
	"mainArea": `styles_mainArea__QWRl4`,
	"authLoading": `styles_authLoading__Dp+Jt`,
	"authCard": `styles_authCard__r-ZQs`,
	"authLogo": `styles_authLogo__6KFj6`,
	"authLogoFloat": `styles_authLogoFloat__j-pgw`,
	"authDots": `styles_authDots__SY-4R`,
	"authDot": `styles_authDot__45kNk`,
	"authDotWave": `styles_authDotWave__sB75W`,
	"mainContent": `styles_mainContent__mEscp`
};
export default ___CSS_LOADER_EXPORT___;
